<template>
  <div class="ins-main platform-main">
    <div class="game groupHeading" ref="game">{{this.$t('lang_men_gamePlatform')}}</div>
    <div class="switch-pc groupDesc">
      <span v-html="$t('lang_gamePlatform_narrative')"></span>
    </div>
    <div class="switch-mb groupDesc">
      <span v-html="$t('lang_gamePlatform_narrative_mb')"></span>
    </div>
    <div class="select-wrap">
      <ul class="select-tab gameLogo-tab">
        <li v-for="(tab,index) in gameNavs" :key="index"
          @click="gameToggleTab(tab.rel,index)"
          :class="{active:index===gameNowIndex}">
          <div>
            <i :class="tab.icon"></i>
            <span>{{ tab.txt }}</span>
          </div>
        </li>
      </ul>
      <div class="platformInfo-inner">
        <ul class="gameLogo clearfix">
          <li v-for="(gameLogo,index) in gameLogos" :key="index">            
            <img :src='require(`@img/${gameLogo.logo}`)'>
          </li>
        </ul>
      </div>
    </div>
    <div class="pay groupHeading" ref="pay">{{this.$t('lang_men_efpayPlatform')}}</div>
    <div class="switch-pc groupDesc">
      <span v-html="$t('lang_efpayPlatform_narrative')"></span>
    </div>
    <div class="switch-mb groupDesc">
      <span v-html="$t('lang_efpayPlatform_narrative_mb')"></span>
    </div>
    <div class="select-wrap">
      <ul class="select-tab payLogo-tab">
        <li v-for="(tab,index) in payNavs"
          @click="payToggleTab(tab.rel,index)" :key="index"
          :class="{active:index===payNowIndex}">
          <div>
            <i :class="tab.icon"></i>
            <span>{{ tab.txt }}</span>
            <i :class="tab.arrow"></i>
          </div>
          <ul class="mb-payLogo clearfix">
            <li v-for="(payLogo,index) in mbPayLogos[index]" :key="index">
              <img :src='require(`@img/${payLogo.logo}`)'>
            </li>
          </ul>
        </li>
      </ul>
      <div class="platformInfo-inner">
        <ul class="payLogo clearfix">
          <li v-for="(payLogo,index) in payLogos" :key="index">
            <img :src='require(`@img/${payLogo.logo}`)'>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import gameLogo from '@data/plat_gameLogo.json'
import payLogo from '@data/plat_payWay.json'

export default {
  name: 'Platform',
  data(){
    return{
      typeName: 'game',
      gameNowIndex: 0,
      gameLogos: [],
      payNowIndex: 0,
      payLogos: [],
      mbPayLogos: [],
    }
  },  
  watch: {
    '$route' (to) {
      this.typeName = to.params.name
      this.getScrollHeight()
    }
  },
  computed: {
    gameNavs(){
      return[
        {
          rel: 'all',
          icon: 'icon-19',
          txt: this.$t('lang_all')
        },
        {
          rel: 'live',
          icon: 'icon-20',
          txt: this.$t('lang_live')
        },
        {
          rel: 'slot',
          icon: 'icon-21',
          txt: this.$t('lang_slot')
        },
        {
          rel: 'sport',
          icon: 'icon-22',
          txt: this.$t('lang_sport')
        },
        {
          rel: 'keno',
          icon: 'icon-23',
          txt: this.$t('lang_lottery')
        },
        {
          rel: 'chess',
          icon: 'icon-33',
          txt: this.$t('lang_chess')
        }
      ]
    },
    payNavs(){
      return[
        {
          rel: 'bank',
          icon: 'icon-24',
          txt: this.$t('lang_men_efpayPlatform'),
          arrow: 'icon-32'
        },
        {
          rel: 'pay',
          icon: 'icon-25',
          txt: this.$t('lang_depositMethod'),
          arrow: 'icon-32'
        },
      ]
    }
  },
  methods: {
    gameLogoInfo(info){
      this.gameLogos=info
    },
    payLogoInfo(info){
      this.payLogos=info
    },
    payToggleTab(data,index){
      this.payNowIndex = index
      this.payLogos = payLogo.filter(function(item){
        if(~item.tag.search(data)){
          return item
        }
      })
    },
    gameToggleTab(data,index){
      this.gameNowIndex = index
      if(data==='all'){
        this.gameLogos = gameLogo
      }else{      
        this.gameLogos = gameLogo.filter(function(item){
          if(~item.tag.indexOf(data)){
            return item
          }        
        })
      }
    },
    mbPayToggleTab(){
      this.mbPayLogos[0] = payLogo.filter(function(item){
        if(~item.tag.indexOf('bank')){
          return item
        }        
      })
      this.mbPayLogos[1] = payLogo.filter(function(item){
        if(~item.tag.indexOf('pay')){
          return item
        }        
      })
    },
    getScrollHeight(init){
      const speed = init === 'mounted' && this.typeName !== 'pay' ? 0 : 500;
      if(this.typeName === 'pay') {
        this.scrollHeight = this.$refs.pay.offsetTop - $('header').outerHeight()
      }else {
        this.scrollHeight = 0
      }

      $('body,html').animate({
        scrollTop: this.scrollHeight
      },speed)
    }
  },
  mounted(){
    const $this = this
    this.gameLogoInfo(gameLogo)
    this.payLogoInfo(payLogo)
    this.gameToggleTab('all',0)
    this.payToggleTab('bank',0)
    this.mbPayToggleTab()

    this.typeName = this.$route.params.name
    this.$nextTick(function(){
      $this.getScrollHeight('mounted')
    })
    
		this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    
		this.$store.dispatch('setLoadshow',true)
  }
}
</script>
<style lang="sass">
  @import '@css/platform.sass'
</style>
